import { createStyles, IconButton, makeStyles, Zoom } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import { useStore } from "../../hooks/useStore";
import { useDispatch } from "react-redux";
import { hideAlert } from "../../redux/actions/types/alertTypes";

const useStyle = makeStyles(() =>
  createStyles({
    root: {
      position: "fixed",
      bottom: "5%",
      zIndex: 99999,
      display: "flex",
      justifyContent: "center",
      width: "100%",
    },
    alert: {
      width: "80%",
      borderRadius: 15,
    },
  })
);

export const GlobalAlert = () => {
  const classes = useStyle();
  const { alertStore } = useStore();
  const dispatch = useDispatch();

  return (
    <Zoom in={alertStore.show} timeout={300}>
      <div className={classes.root}>
        <Alert
          className={classes.alert}
          variant="filled"
          severity={alertStore.severity}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                dispatch(hideAlert());
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {alertStore.title}
        </Alert>
      </div>
    </Zoom>
  );
};
